import React from 'react'
import MaterialSymbol from '../material-symbol'

const Timer = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="timer" {...props} />
))

Timer.displayName = 'Timer'

export default Timer
